import { Component, ViewChild, TemplateRef, ElementRef, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule, DatePipe } from '@angular/common';
import { BsDatepickerModule, DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AppService } from '../app.service';
import { qmsService } from '../qms/qms.service';
import { forkJoin, firstValueFrom } from 'rxjs';
import { PaginationService } from 'src/app/PaginationService';
import { MatPaginatorModule } from '@angular/material/paginator';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { messageService } from '../message.service';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
//import { EChartsOption } from 'echarts';
import { SimpleChartComponent } from '../AST_Charts/simple-chart.component';
import { ChartOptions } from '../AST_Charts/chart-options.model';
import { FormsModule } from '@angular/forms';
interface UserStatusDataPoint {
  userStatus: string;
  y: number;
}
@Component({
  selector: 'app-one-qsm-admin-report',
  templateUrl: './one-qms-admin-report.component.html',
  styleUrls: ['./one-qms-admin-report.component.scss'],
})


export class OneQmsAdminReportComponent implements OnInit {
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  reportName: any;
  isSaveReport: boolean = false;
  chartOptionsForUserStatusZoom: any;
  chartOptionsForUserLoginInactivityZoom: any;
  chartOptionsForConcurentUserZoom: any;
  chartOptionsForDepartmentZoom: any;
  chartOptionsForDesignationZoom: any;
  chartOptionsForTimeZoneZoom: any;
  chartOptionsForGroupZoom: any;

  updateIsAdUser(_t108: any) {
    throw new Error('Method not implemented.');
  }

  isProcessing: boolean = false;
  showCharts: boolean = false;
  showReportFlagValue: any;
  showReportFlagValueTotal: any;
  typeOfGroup: any;
  PageName: any;
  searchValue: any;
  error = '';
  makeStickyColumns: any;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  statusCodeValue: any;
  columnLists: any = {};
  dataTypeList: any = [];
  array: any = [];
  dropDownForModules: any;
  popupTitle: any;
  groupValueDropdown: any = [];
  groupdataList: any = [];
  stageAndStatus: any = [];
  dropDownForDateRange: any = [];
  dropDownForInterval: any = [];
  stageValueDropdown: any = [];
  dateRangeValueDropdown: any = [];
  statusValueDropdown: any = [];
  intervalValueDropdown: any = [];
  selectedStatusValue: any = [];
  selectedDateRangeValue: any = [];
  selectedIntervalValue: any = [];
  selectedStageValue: any = [];
  selectedGroupValue: any = [];
  fromDate: any;
  toDate: any;
  showSpecificInterval: boolean = false;
  titleName = '';
  clickedType = '';
  clickedVal = '';
  clickedStageStatusVal = '';
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = 'Showing results';
  displayingClaimsText = 'Displaying claims';
  rowText = 'Rows';
  showingRowsText = 'Showing rows';
  users: any[];
  pager: any = {};
  pagedItems: any[];
  pagedItems1: any[];
  pagedItems5: any[];
  pagedItems6: any[];

  dateCustomClasses: DatepickerDateCustomClasses[];
  //chartOptionsForUserStatus: any;
  chartOptionsForUserStatus!: ChartOptions;
  chartOptionsForDepartment!: ChartOptions;
  chartOptionsForUserStatusExcluded: any;
  chartOptionsForConcurentUser: any;
  chartOptionsForUserLoginInactivity: any;
  chartOptionsForDesignation: any;
  chartOptionsForTimeZone: any;
  //chartOptionsForDepartment: any;
  chartOptionsForGroup: any;

  chartOptionsForStagesStatus: any;

  tableReportDataList: any = [];
  TableReportDataListForUserLoginInactive: any = [];
  tableReportDataListTotal: any = [];
  TableReportDataListForUserLoginInactiveTotal: any = [];
  whereValsForExcel: any;

  constructor(
    public dialog: MatDialog,
    public appService: AppService,
    public router: Router,
    public snackBar: MatSnackBar,
    public message: messageService,
    public elem: ElementRef,
    public paginationService: PaginationService,
    public qmsservice: qmsService,
    public datePipe: DatePipe,
    public activatedRoute: ActivatedRoute,
    public atPaginatorModule: MatPaginatorModule
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }
  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;

  reportPopupConfig = {
    width: '120%',
    height: '680px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px', left: '125px' },
    maxWidth: '90vw',
  };

  @ViewChild('reportPopupForZoom', { static: true })
  reportPopupForZoom: TemplateRef<any>;
  visibleReportPopupForZoom: MatDialogRef<TemplateRef<any>>;
  moreAdminReportDetails(value: any) {
    if (value == 'Default') {
      this.qmsservice.adminReportFor = value;
      this.message.breadcrumbData.thirdLevel = '';
      this.router.navigate(['/dashboard/OneQmsAdminReportComponent']);
    } else {
      this.qmsservice.adminReportFor = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.router.navigate([
        '/dashboard/OneQmsMoreAdminReportDetailsComponent',
      ]);
    }
  }
  clickedChartVal: any;
  adminChartDoubleClick(val: any) {
    this.createAdminChartZoom(val);
    this.clickedChartVal = val;
    this.visibleReportPopupForZoom = this.dialog.open(
      this.reportPopupForZoom,
      this.reportPopupConfig
    );
    if (val == 1) {
      this.tableDataListAll('isActive', '', 'I');
      this.clickedType = 'isActive';
      this.clickedVal = 'isActive';
      this.clickedStageStatusVal = '';
    } else if (val == 3) {
      this.tableDataListAll('UserLoginInactivity', '', '');
      this.clickedType = 'UserLoginInactivity';
      this.clickedVal = 'UserLoginInactivity';
      this.clickedStageStatusVal = '';
    } else if (val == 4) {
      this.tableDataListAll('department', '', '');
      this.clickedType = 'department';
      this.clickedVal = 'department';
      this.clickedStageStatusVal = '';
    } else if (val == 5) {
      this.tableDataListAll('designation', '', '');
      this.clickedType = 'designation';
      this.clickedVal = 'designation';
      this.clickedStageStatusVal = '';
    } else if (val == 6) {
      this.tableDataListAll('timeZone', '', '');
      this.clickedType = 'timeZone';
      this.clickedVal = 'timeZone';
      this.clickedStageStatusVal = '';
    }
  }
  createAdminChartZoom(val: any) {
    if (val == 1) {
      this.chartOptionsForUserStatusZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: 'xy',
        toolbar: {
          itemBackgroundColor: '#d3d3d3',
          itemBackgroundColorOnHover: '#3e3e3e',
          buttonBorderColor: '#3e3e3e',
          icon: {
            zoom: {
              backgroundColor: '#007BFF', // Set the background color for the zoom icon
              borderColor: '#007BFF', // Set the border color for the zoom icon
              borderWidth: 1, // Set the border width for the zoom icon
            },
          },
        },
        legend: {
          cursor: 'pointer',
          maxWidth: 370,
          horizontalAlign: 'left',
          fontSize: 12,
          fontFamily: 'Poppins',
          fontColor: '#0F3659',
          fontWeight: 'normal',
        },
        title: {
          text: `User Status (${this.getTotalCountActiveChart()})`,
          fontSize: 20,
          fontFamily: 'Poppins',
          horizontalAlign: 'left',
          fontColor: '#0F3659',
          fontWeight: 'bold',
          click: function (e: any) {
            console.log('Title clicked!');
          },
        },
        data: [
          {
            type: 'pie',
            startAngle: -90,
            indexLabel: '{userStatus}',
            showInLegend: true,
            legendText: '{indexLabel}',
            yValueFormatString: "#,###.##''",
            dataPoints: this.getDataPointsForUserStatusExcluded(),
            click: this.handleIsActiveChartClick.bind(this), // Reference the click event handler for the entire pie chart
          },
        ],
      };
    }
    if (val == 2) {
      this.chartOptionsForConcurentUserZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: 'xy',
        toolbar: {
          itemBackgroundColor: '#d3d3d3',
          itemBackgroundColorOnHover: '#3e3e3e',
          buttonBorderColor: '#3e3e3e',
          icon: {
            zoom: {
              backgroundColor: '#007BFF', // Set the background color for the zoom icon
              borderColor: '#007BFF', // Set the border color for the zoom icon
              borderWidth: 1, // Set the border width for the zoom icon
            },
          },
        },
        legend: {
          cursor: 'pointer',
          maxWidth: 370,
          // itemWidth: 150,
          horizontalAlign: 'left',
          fontSize: 12,
          fontFamily: 'Poppins',
          fontColor: '#0F3659',
          fontWeight: 'normal',
        },
        title: {
          text: 'Concurrent Users',
          fontSize: 20,
          fontFamily: 'Poppins',
          horizontalAlign: 'left',
          fontColor: '#0F3659',
          fontWeight: 'bold',
          click: function (e: any) {
            // Your title click event handler logic goes here
            console.log('Title clicked!');
          },
        },
        data: [
          {
            type: 'pie',
            startAngle: -90,
            indexLabel: '{isActive}',
            showInLegend: true,
            legendText: '{indexLabel}',
            yValueFormatString: "#,###.##''",
            dataPoints: this.getDataPointsForUserStatus(),
            click: this.handleIsActiveWithIncludedChartClick.bind(this), // Reference the click event handler for the entire pie chart
          },
        ],
      };
    }
    if (val == 3) {
      this.chartOptionsForUserLoginInactivityZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: 'xy',
        toolbar: {
          itemBackgroundColor: '#d3d3d3',
          itemBackgroundColorOnHover: '#3e3e3e',
          buttonBorderColor: '#3e3e3e',
          icon: {
            zoom: {
              backgroundColor: '#007BFF', // Set the background color for the zoom icon
              borderColor: '#007BFF', // Set the border color for the zoom icon
              borderWidth: 1, // Set the border width for the zoom icon
            },
          },
        },
        legend: {
          cursor: 'pointer',
          maxWidth: 370,
          horizontalAlign: 'left',
          fontSize: 12,
          fontFamily: 'Poppins',
          fontColor: '#0F3659',
          fontWeight: 'normal',
        },
        title: {
          text: `User Login Inactivity (${this.getTotalCountLoginInactivity()})`,
          fontSize: 20,
          fontFamily: 'Poppins',
          horizontalAlign: 'left',
          fontColor: '#0F3659',
          fontWeight: 'bold',
          click: function (e: any) {
            console.log('Title clicked!');
          },
        },
        data: [
          {
            type: 'pie',
            startAngle: -90,
            indexLabel: '{lastLogonBefore}',
            showInLegend: true,
            legendText: '{indexLabel}',
            yValueFormatString: "#,###.##''",
            dataPoints: this.getDataPointsForUserLoginInactivity(),
            click: this.handleUserLoginInactivityChartClick.bind(this), // Reference the click event handler for the entire pie chart
          },
        ],
      };
    }
    if (val == 4) {
      this.chartOptionsForDepartmentZoom = {
        animationEnabled: true,
        exportEnabled: true,
        legend: {
          cursor: 'pointer',
        },
        title: {
          text: `Department (${this.getTotalCountDepartment()})`,
          fontSize: 20,
          fontFamily: 'Poppins',
          horizontalAlign: 'left',
          fontColor: '#0F3659',
          fontWeight: 'bold',
          click: function (e: any) {
            console.log('Title clicked!');
          },
        },
        dataPointMaxWidth: 38,
        dataPointMinWidth: 38,
        axisY: {
          gridThickness: 1,
          gridColor: '#DEEBFE80',
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: '#0F3659',
          labelFontFamily: 'Poppins',
        },
        axisX: {
          labelAngle: this.departmentList.length > 15 ? -45 : 0,
          tickLength: 0,
          lineThickness: 0,
          interval: 1, // Show every label
          labelFontSize: 12,
          labelFontColor: '#0F3659',
          labelFontFamily: 'Poppins',
          labelFormatter: function (e: { label: string }) {
            if (e.label) {
              // Truncate labels longer than 5 characters and add '...'
              return e.label.length > 5
                ? e.label.substring(0, 5) + '...'
                : e.label;
            }
            return '';
          },
        },
        data: [
          {
            type: 'column', // Use "horizontalBar" for horizontal bar chart
            color: '#00A6A9',
            indexLabelFontColor: '#0F3659',
            indexLabelFontSize: 12,
            indexLabelFontFamily: 'Poppins',
            indexLabel: '{y}',
            dataPoints: this.getDataPointsForDepartment(),
            click: this.handleDepartmentChartClick.bind(this),
          },
        ],
      };
    }
    if (val == 5) {
      this.chartOptionsForDesignationZoom = {
        animationEnabled: true,
        exportEnabled: true,
        legend: {
          cursor: 'pointer',
        },
        title: {
          text: `Designation (${this.getTotalCountDesignation()})`,
          fontSize: 20,
          fontFamily: 'Poppins',
          horizontalAlign: 'left',
          fontColor: '#0F3659',
          fontWeight: 'bold',
          click: function (e: any) {
            console.log('Title clicked!');
          },
        },
        dataPointMaxWidth: 38,
        dataPointMinWidth: 38,
        axisY: {
          gridThickness: 1,
          gridColor: '#DEEBFE80',
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: '#0F3659',
          labelFontFamily: 'Poppins',
        },
        axisX: {
          labelAngle: this.departmentList.length > 15 ? -45 : 0,
          tickLength: 0,
          lineThickness: 0,
          interval: 1, // Show every label
          labelFontSize: 12,
          labelFontColor: '#0F3659',
          labelFontFamily: 'Poppins',
          labelFormatter: function (e: { label: string }) {
            if (e.label) {
              // Truncate labels longer than 5 characters and add '...'
              return e.label.length > 5
                ? e.label.substring(0, 5) + '...'
                : e.label;
            }
            return '';
          },
        },
        data: [
          {
            type: 'column', // Use "horizontalBar" for horizontal bar chart
            color: '#00A6A9',
            indexLabel: '{y}',
            indexLabelFontColor: '#0F3659',
            indexLabelFontSize: 12,
            indexLabelFontFamily: 'Poppins',
            dataPoints: this.getDataPointsForDesignation(),
            click: this.handleDesignationChartClick.bind(this),
          },
        ],
      };
    }

    if (val == 6) {
      this.chartOptionsForTimeZoneZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: 'xy',
        toolbar: {
          itemBackgroundColor: '#d3d3d3',
          itemBackgroundColorOnHover: '#3e3e3e',
          buttonBorderColor: '#3e3e3e',
          icon: {
            zoom: {
              backgroundColor: '#007BFF', // Set the background color for the zoom icon
              borderColor: '#007BFF', // Set the border color for the zoom icon
              borderWidth: 1, // Set the border width for the zoom icon
            },
          },
        },
        legend: {
          cursor: 'pointer',
          maxWidth: 370,
          horizontalAlign: 'left',
          fontSize: 12,
          fontFamily: 'Poppins',
          fontColor: '#0F3659',
          fontWeight: 'normal',
        },
        title: {
          text: `Time Zone (${this.getTotalCountTimeZoneChart()})`,
          fontSize: 20,
          fontFamily: 'Poppins',
          horizontalAlign: 'left',
          fontColor: '#0F3659',
          fontWeight: 'bold',
          click: function (e: any) {
            console.log('Title clicked!');
          },
        },
        data: [
          {
            type: 'doughnut',
            indexLabel: '{taskType}',
            showInLegend: true,
            legendText: '{indexLabel}',
            yValueFormatString: "#,###.##''",
            dataPoints: this.getDataPointsForTimeZone(),
            click: this.handleTimeZoneChartClick.bind(this), // Reference the click event handler for the entire pie chart
          },
        ],
      };
    }
    if (val == 7) {
      this.chartOptionsForGroupZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: 'xy',
        toolbar: {
          itemBackgroundColor: '#d3d3d3',
          itemBackgroundColorOnHover: '#3e3e3e',
          buttonBorderColor: '#3e3e3e',
          icon: {
            zoom: {
              backgroundColor: '#007BFF', // Set the background color for the zoom icon
              borderColor: '#007BFF', // Set the border color for the zoom icon
              borderWidth: 1, // Set the border width for the zoom icon
            },
          },
        },
        legend: {
          cursor: 'pointer',
          maxWidth: 370,
          horizontalAlign: 'left',
          fontSize: 12,
          fontFamily: 'Poppins',
          fontColor: '#0F3659',
          fontWeight: 'normal',
        },
        title: {
          text: 'Groups',
          fontSize: 20,
          fontFamily: 'Poppins',
          horizontalAlign: 'left',
          fontColor: '#0F3659',
          fontWeight: 'bold',
          click: function (e: any) {
            console.log('Title clicked!');
          },
        },
        data: [
          {
            type: 'pie',
            startAngle: -90,
            indexLabel: '{value}',
            showInLegend: true,
            legendText: '{indexLabel}',
            yValueFormatString: "#,###.##''",
            dataPoints: this.getDataPointsForGroup(),
            click: this.handleGroupChartClick.bind(this), // Reference the click event handler for the entire pie chart
          },
        ],
      };
    }
  }
  cancelReportPopupForZoomFunction() {
    this.visibleReportPopupForZoom.close();
    this.showReportFlagValueTotal = '';
    this.showReportFlagValue = '';
  }
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    for (const groupData of this.groupdataList) {
      this.groupValueDropdown = this.groupValueDropdown.concat({
        valueExp: groupData.groupId,
        displayExp: groupData.groupName,
      });
    }
  }
  moveTop() {
    this.showCharts = true;
    setTimeout(() => {
      window.scrollTo({ top: 70, behavior: 'smooth' });
    }, 1000);
  }
  //public chartOptionsForUserStatus: EChartsOption = {};

  private dataPoints: UserStatusDataPoint[] = [];

  createChart() {
    this.dataPoints = this.getDataPointsForUserStatusExcluded();
    this.chartOptionsForUserStatus = {
      type: 'pie',
      animate: true,
      title: `User Status (${this.getTotalCountActiveChart()})`,
      showLegend: true,
      series: [
        {
          name: 'User Status',
          data: this.getDataPointsForUserStatusExcluded().map((dp: { userStatus: any; y: any; color: any; }) => ({
            x: dp.userStatus,
            y: dp.y,
            color: dp.color,
          })),
        },
      ],
      onClick: (point) => {
        console.log("this.userList1=============", point.x);
        this.handleIsActiveChartClick(point.x as string);
      },
    };

    // this.chartOptionsForUserStatus = {
    //   type: 'pie',
    //   title: `User Status (${this.getTotalCountActiveChart()})`,
    //   showLegend: true,
    //   animate: true,
    //   series: [
    //     {
    //       name: 'User Status',
    //       data: this.dataPoints.map((dp: UserStatusDataPoint) => ({
    //         x: dp.userStatus,
    //         y: dp.y,
    //       })),
    //     },
    //   ],
    //   onClick: (point) => {
    //     this.titleName = 'Task Type Report';
    //     this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    //     this.tableDataList('isActive', point.x, 'I');
    //     this.clickedType = 'User Status';
    //     this.clickedVal = point.x as string;
    //     this.clickedStageStatusVal = '';
    //   },
    // };
    // this.chartOptionsForUserStatus : ChartOptions = {
    //   title: {
    //     text: `User Status (${this.getTotalCountActiveChart()})`,
    //     left: 'left',
    //     textStyle: {
    //       fontSize: 20,
    //       fontFamily: 'Poppins',
    //       fontWeight: 'bold',
    //       color: '#0F3659',
    //     },
    //   },
    //   legend: {
    //     left: 'left',
    //     top: 'bottom',
    //     icon: 'circle',
    //     textStyle: {
    //       fontSize: 12,
    //       fontFamily: 'Poppins',
    //       color: '#0F3659',
    //       fontWeight: 'normal',
    //     },
    //   },
    //   tooltip: {
    //     trigger: 'item',
    //     formatter: (params: any) => {
    //       const formatted = Number(params.value).toLocaleString();
    //       return `${params.name}: ${formatted}''`;
    //     },
    //   },
    //   toolbox: {
    //     show: true,
    //     right: 10,
    //     itemSize: 16,
    //     iconStyle: {
    //       color: '#d3d3d3',
    //       borderColor: '#3e3e3e',
    //     },
    //     emphasis: {
    //       iconStyle: {
    //         color: '#3e3e3e',
    //       },
    //     },
    //     feature: {
    //       saveAsImage: {
    //         title: 'Export',
    //       },
    //       dataZoom: {
    //         title: { zoom: 'Zoom', back: 'Reset' },
    //         iconStyle: {
    //           color: '#007BFF',
    //           borderColor: '#007BFF',
    //           borderWidth: 1,
    //         },
    //       },
    //     },
    //   },
    //   series: [
    //     {
    //       name: 'User Status',
    //       type: 'pie',
    //       startAngle: -90,
    //       radius: '60%',
    //       label: {
    //         formatter: '{b}',
    //       },
    //       labelLine: {
    //         show: true,
    //       },
    //       data: this.dataPoints.map((dp: UserStatusDataPoint) => ({
    //         name: dp.userStatus,
    //         value: dp.y,
    //       })),
    //     },
    //   ],
    // };


    // this.chartOptionsForUserStatus = {
    //   animationEnabled: true,
    //   exportEnabled: true,
    //   zoomEnabled: true,
    //   zoomType: 'xy',
    //   creditText: ' ',
    //   creditHref: ' ',
    //   toolbar: {
    //     itemBackgroundColor: '#d3d3d3',
    //     itemBackgroundColorOnHover: '#3e3e3e',
    //     buttonBorderColor: '#3e3e3e',
    //     icon: {
    //       zoom: {
    //         backgroundColor: '#007BFF',
    //         borderColor: '#007BFF',
    //         borderWidth: 1,
    //       },
    //     },
    //   },
    //   legend: {
    //     cursor: 'pointer',
    //     maxWidth: 370,
    //     horizontalAlign: 'left',
    //     fontSize: 12,
    //     fontFamily: 'Poppins',
    //     fontColor: '#0F3659',
    //     fontWeight: 'normal',
    //   },
    // title: `User Status (${this.getTotalCountActiveChart()})`,
    //   data: [
    //     {
    //       type: 'pie',
    //       startAngle: -90,
    //       indexLabel: '{userStatus}',
    //       showInLegend: true,
    //       legendText: '{indexLabel}',
    //       yValueFormatString: "#,###.##''",
    //       dataPoints: this.getDataPointsForUserStatusExcluded(),
    //       click: this.handleIsActiveChartClick.bind(this),
    //     },
    //   ],
    //   axisX: {
    //     margin: 20
    //   }
    // };

    this.chartOptionsForConcurentUser = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: 'xy',
      toolbar: {
        itemBackgroundColor: '#d3d3d3',
        itemBackgroundColorOnHover: '#3e3e3e',
        buttonBorderColor: '#3e3e3e',
        icon: {
          zoom: {
            backgroundColor: '#007BFF', // Set the background color for the zoom icon
            borderColor: '#007BFF', // Set the border color for the zoom icon
            borderWidth: 1, // Set the border width for the zoom icon
          },
        },
      },
      legend: {
        cursor: 'pointer',
        maxWidth: 370,
        horizontalAlign: 'left',
        fontSize: 12,
        fontFamily: 'Poppins',
        fontColor: '#0F3659',
        fontWeight: 'normal',
      },
      title: {
        text: 'Concurrent Users',
        fontSize: 20,
        fontFamily: 'Poppins',
        horizontalAlign: 'left',
        fontColor: '#0F3659',
        fontWeight: 'bold',
        click: function (e: any) {
          console.log('Title clicked!');
        },
      },
      data: [
        {
          type: 'pie',
          startAngle: -90,
          indexLabel: '{isActive}',
          showInLegend: true,
          legendText: '{indexLabel}',
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForUserStatus(),
          click: this.handleIsActiveWithIncludedChartClick.bind(this), // Reference the click event handler for the entire pie chart
        },
      ],
    };

    this.chartOptionsForUserLoginInactivity = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: 'xy',
      toolbar: {
        itemBackgroundColor: '#d3d3d3',
        itemBackgroundColorOnHover: '#3e3e3e',
        buttonBorderColor: '#3e3e3e',
        icon: {
          zoom: {
            backgroundColor: '#007BFF', // Set the background color for the zoom icon
            borderColor: '#007BFF', // Set the border color for the zoom icon
            borderWidth: 1, // Set the border width for the zoom icon
          },
        },
      },
      legend: {
        cursor: 'pointer',
        maxWidth: 370,
        horizontalAlign: 'left',
        fontSize: 12,
        fontFamily: 'Poppins',
        fontColor: '#0F3659',
        fontWeight: 'normal',
      },
      title: {
        text: `User Login Inactivity (${this.getTotalCountLoginInactivity()})`,
        fontSize: 20,
        fontFamily: 'Poppins',
        horizontalAlign: 'left',
        fontColor: '#0F3659',
        fontWeight: 'bold',
        click: function (e: any) {
          console.log('Title clicked!');
        },
      },
      data: [
        {
          type: 'pie',
          startAngle: -90,
          indexLabel: '{lastLogonBefore}',
          showInLegend: true,
          legendText: '{indexLabel}',
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForUserLoginInactivity(),
          click: this.handleUserLoginInactivityChartClick.bind(this), // Reference the click event handler for the entire pie chart
        },
      ],
    };


    // this.chartOptionsForDepartment = {
    //   type: 'bar',
    //   animate: true,
    //   title: {
    //     text: `Department (${this.getTotalCountDepartment()})`,
    //     fontSize: 20,
    //     fontFamily: 'Poppins',
    //     fontWeight: 'bold',
    //     color: '#0F3659',
    //     align: 'left',
    //   },
    //   colors: ['#00A6A9'],
    //   series: [
    //     {
    //       name: 'Department',
    //       data: this.getDataPointsForDepartment().map((dp: any) => ({
    //         x: dp.label,
    //         y: dp.y,
    //       })),
    //     },
    //   ], onClick: (point: any) => {
    //     console.log("this.userList1=============", point.x);
    //     this.handleDepartmentChartClick(point.x as string);
    //   },
    //   // onClick: (point) => {
    //   //   // dataIndex maps 1:1 back to departmentList's original order — avoids
    //   //   // any label-matching issues, same pattern as your old dataPointIndex
    //   //   this.handleDepartmentChartClick({ dataPointIndex: point.dataIndex });
    //   // },
    // };
    this.chartOptionsForDepartment = {
      type: 'bar',
      animate: true,
      dataLabels: true,  // shows the value above each bar, like your old indexLabel: '{y}'
      title: {
        text: `Department (${this.getTotalCountDepartment()})`,
        fontSize: 20,
        fontFamily: 'Poppins',
        fontWeight: 'bold',
        color: '#0F3659',
        align: 'left',
      },
      colors: ['#00A6A9'],
      axisX: {
        labelAngle: this.departmentList.length > 15 ? -45 : 0,
        labelColor: '#0F3659',
        labelFontFamily: 'Poppins',
        labelFontSize: 12,
        labelFormatter: (e: { label: string }) =>
          e.label.length > 5 ? e.label.substring(0, 5) + '...' : e.label,
      },
      axisY: {
        gridColor: '#DEEBFE80',
        labelColor: '#0F3659',
        labelFontFamily: 'Poppins',
        labelFontSize: 12,
      },
      series: [
        {
          name: 'Department',
          data: this.getDataPointsForDepartment().map((dp: any) => ({ x: dp.label, y: dp.y })),
        },
      ], onClick: (point: any) => {
        console.log("this.userList1=============", point.x);
        this.handleDepartmentChartClick(point.x as string);
      },
    };
    // this.chartOptionsForDepartment = {
    //   animationEnabled: true,
    //   exportEnabled: true,
    //   legend: {
    //     cursor: 'pointer',
    //   },
    //   title: {
    //     text: `Department (${this.getTotalCountDepartment()})`,
    //     fontSize: 20,
    //     fontFamily: 'Poppins',
    //     horizontalAlign: 'left',
    //     fontColor: '#0F3659',
    //     fontWeight: 'bold',
    //     click: function (e: any) {
    //       console.log('Title clicked!');
    //     },
    //   },
    //   dataPointMaxWidth: 38,
    //   dataPointMinWidth: 38,
    //   axisY: {
    //     gridThickness: 1,
    //     gridColor: '#DEEBFE80',
    //     tickLength: 0,
    //     lineThickness: 0,
    //     labelFontSize: 12,
    //     labelFontColor: '#0F3659',
    //     labelFontFamily: 'Poppins',
    //   },
    //   axisX: {
    //     labelAngle: this.departmentList.length > 15 ? -45 : 0,
    //     tickLength: 0,
    //     lineThickness: 0,
    //     interval: 1, // Show every label
    //     labelFontSize: 12,
    //     labelFontColor: '#0F3659',
    //     labelFontFamily: 'Poppins',
    //     labelFormatter: function (e: { label: string }) {
    //       if (e.label) {
    //         // Truncate labels longer than 5 characters and add '...'
    //         return e.label.length > 5
    //           ? e.label.substring(0, 5) + '...'
    //           : e.label;
    //       }
    //       return '';
    //     },
    //   },
    //   data: [
    //     {
    //       type: 'column', // Use "horizontalBar" for horizontal bar chart
    //       color: '#00A6A9',
    //       indexLabelFontColor: '#0F3659',
    //       indexLabelFontSize: 12,
    //       indexLabelFontFamily: 'Poppins',
    //       indexLabel: '{y}',
    //       dataPoints: this.getDataPointsForDepartment(),
    //       click: this.handleDepartmentChartClick.bind(this),
    //     },
    //   ],
    // };

    this.chartOptionsForDesignation = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: 'pointer',
      },
      title: {
        text: `Designation (${this.getTotalCountDesignation()})`,
        fontSize: 20,
        fontFamily: 'Poppins',
        horizontalAlign: 'left',
        fontColor: '#0F3659',
        fontWeight: 'bold',
        click: function (e: any) {
          console.log('Title clicked!');
        },
      },
      dataPointMaxWidth: 38,
      dataPointMinWidth: 38,
      axisY: {
        gridThickness: 1,
        gridColor: '#DEEBFE80',
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: '#0F3659',
        labelFontFamily: 'Poppins',
      },
      axisX: {
        labelAngle: this.departmentList.length > 15 ? -45 : 0,
        tickLength: 0,
        lineThickness: 0,
        interval: 1, // Show every label
        labelFontSize: 12,
        labelFontColor: '#0F3659',
        labelFontFamily: 'Poppins',
        labelFormatter: function (e: { label: string }) {
          if (e.label) {
            // Truncate labels longer than 5 characters and add '...'
            return e.label.length > 5
              ? e.label.substring(0, 5) + '...'
              : e.label;
          }
          return '';
        },
      },
      data: [
        {
          type: 'column', // Use "horizontalBar" for horizontal bar chart
          color: '#00A6A9',
          indexLabel: '{y}',
          indexLabelFontColor: '#0F3659',
          indexLabelFontSize: 12,
          indexLabelFontFamily: 'Poppins',
          dataPoints: this.getDataPointsForDesignation(),
          click: this.handleDesignationChartClick.bind(this),
        },
      ],
    };

    this.chartOptionsForTimeZone = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: 'xy',
      toolbar: {
        itemBackgroundColor: '#d3d3d3',
        itemBackgroundColorOnHover: '#3e3e3e',
        buttonBorderColor: '#3e3e3e',
        icon: {
          zoom: {
            backgroundColor: '#007BFF', // Set the background color for the zoom icon
            borderColor: '#007BFF', // Set the border color for the zoom icon
            borderWidth: 1, // Set the border width for the zoom icon
          },
        },
      },
      legend: {
        cursor: 'pointer',
        maxWidth: 370,
        // itemWidth: 150,
        horizontalAlign: 'left',
        fontSize: 12,
        fontFamily: 'Poppins',
        fontColor: '#0F3659',
        fontWeight: 'normal',
      },
      title: {
        text: `Time Zone (${this.getTotalCountTimeZoneChart()})`,
        fontSize: 20,
        fontFamily: 'Poppins',
        horizontalAlign: 'left',
        fontColor: '#0F3659',
        fontWeight: 'bold',
        click: function (e: any) {
          console.log('Title clicked!');
        },
      },
      data: [
        {
          type: 'doughnut',
          indexLabel: '{taskType}',
          showInLegend: true,
          legendText: '{indexLabel}',
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForTimeZone(),
          click: this.handleTimeZoneChartClick.bind(this), // Reference the click event handler for the entire pie chart
        },
      ],
    };

    this.chartOptionsForGroup = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: 'xy',
      toolbar: {
        itemBackgroundColor: '#d3d3d3',
        itemBackgroundColorOnHover: '#3e3e3e',
        buttonBorderColor: '#3e3e3e',
        icon: {
          zoom: {
            backgroundColor: '#007BFF', // Set the background color for the zoom icon
            borderColor: '#007BFF', // Set the border color for the zoom icon
            borderWidth: 1, // Set the border width for the zoom icon
          },
        },
      },
      legend: {
        cursor: 'pointer',
        maxWidth: 370,
        horizontalAlign: 'left',
        fontSize: 12,
        fontFamily: 'Poppins',
        fontColor: '#0F3659',
        fontWeight: 'normal',
      },
      title: {
        text: 'Groups',
        fontSize: 20,
        fontFamily: 'Poppins',
        horizontalAlign: 'left',
        fontColor: '#0F3659',
        fontWeight: 'bold',
        click: function (e: any) {
          console.log('Title clicked!');
        },
      },
      data: [
        {
          type: 'pie',
          startAngle: -90,
          indexLabel: '{value}',
          showInLegend: true,
          legendText: '{indexLabel}',
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForGroup(),
          click: this.handleGroupChartClick.bind(this), // Reference the click event handler for the entire pie chart
        },
      ],
    };
    this.moveTop();
  }
  colorList: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#839EFF',
    '#00A6A9',
    '#0081A5',
    '#291F1E',
    '#401F3E',
    '#C0DFA1',
    '#14342B',
    '#D0DB97',
    '#B07BAC',
    '#CF1259',
    '#E6B89C',
  ];
  colorMethod(val: any, iVal: any) {
    if (val == 'Closed' || val == 'Completed' || val == 'Passed') {
      return '#96E480';
    } else if (val == 'Critical' || val == 'High') {
      return '#EB5757';
    } else if (val == 'Major' || val == 'Medium') {
      return '#FF947A';
    } else if (val == 'In Progress' || val == 'Minor') {
      return '#005C8A';
    } else {
      return this.colorList[iVal];
    }
  }
  getDataPointsForUserStatus() {
    const dataPoints = this.userList.map(
      (ul: { count: any; isActive: any }, index: any) => ({
        y: ul.count,
        indexLabel: `${ul.isActive}: ${ul.count}`,
        color: this.colorMethod(ul.isActive, index),
      })
    );
    return dataPoints;
  }
  getDataPointsForUserLoginInactivity() {
    const dataPoints = this.UserLoginInactivityList.map(
      (ulI: { count: any; lastLogonBefore: any }, index: any) => ({
        y: ulI.count,
        indexLabel: `${ulI.lastLogonBefore}: ${ulI.count}`,
        color: this.colorMethod(ulI.lastLogonBefore, index),
      })
    );
    return dataPoints;
  }

  getDataPointsForUserStatusExcluded() {
    const dataPoints = this.userList1.map(
      (ul: { count: any; userStatus: any }, index: any) => ({
        userStatus: ul.userStatus,
        y: ul.count,
        color: this.colorMethod(ul.userStatus, index),
      })
    );
    return dataPoints;
  }
  // getDataPointsForUserStatusExcluded() {
  //   console.log("this.userList1", this.userList1);
  //   const dataPoints = this.userList1.map(
  //     (ul: { count: any; userStatus: any }, index: any) => ({
  //       y: ul.count,
  //       indexLabel: `${ul.userStatus}: ${ul.count}`,
  //       color: this.colorMethod(ul.userStatus, index),
  //     })
  //   );
  //   return dataPoints;
  // }
  getDataPointsForTimeZone() {
    const dataPoints = this.timeZoneList.map(
      (tzl: { count: any; timezone: any }, index: any) => ({
        y: tzl.count,
        indexLabel: `${tzl.timezone}: ${tzl.count}`,
        color: this.colorMethod(tzl.timezone, index),
      })
    );
    return dataPoints;
  }
  getDataPointsForDesignation() {
    const dataPoints = this.designationList.map(
      (desc: { count: any; designation: any }) => ({
        label: desc.designation,
        y: desc.count,
      })
    );
    return dataPoints;
  }
  getDataPointsForDepartment() {
    const dataPoints = this.departmentList.map(
      (dep: { count: any; department: any }) => ({
        label: dep.department,
        y: dep.count,
      })
    );
    return dataPoints;
  }

  getDataPointsForGroup() {
    const dataPoints = this.allGroupCount.map(
      (gc: { count: any; value: any }, index: any) => ({
        y: gc.count,
        indexLabel: `${gc.value}: ${gc.count}`,
        color: this.colorMethod(gc.value, index),
      })
    );
    return dataPoints;
  }
  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
  }

  // handleIsActiveChartClick(e: any): void {
  //   this.titleName = 'Task Type Report';
  //   this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
  //   this.tableDataList(
  //     'isActive',
  //     this.userList1[e.dataPointIndex].userStatus,   // ← e is now a string, e.dataPointIndex is undefined
  //     'I'
  //   );
  //   this.clickedType = 'User Status';
  //   this.clickedVal = this.userList1[e.dataPointIndex].userStatus;
  //   this.clickedStageStatusVal = '';
  // }
  handleIsActiveChartClick(userStatus: string): void {
    console.log("this.userList1=============", this.userList1);
    this.titleName = 'Task Type Report';
    this.visibleReportPopup = this.dialog.open(
      this.reportPopup,
      this.reportPopupConfig
    );
    this.tableDataList('isActive', userStatus, 'I');
    this.clickedType = 'User Status';
    this.clickedVal = userStatus;
    this.clickedStageStatusVal = '';
  }
  getTotalCountActiveChart() {
    return this.userList1.reduce(
      (total: number, item: { count: number }) => total + item.count,
      0
    );
  }
  handleIsActiveWithIncludedChartClick(e: any): void {
    this.titleName = 'Concurrent User Active';
    this.visibleReportPopup = this.dialog.open(
      this.reportPopup,
      this.reportPopupConfig
    );
    this.tableDataList(
      'concurrent',
      this.userList[e.dataPointIndex].isActive,
      ''
    );
    this.clickedType = 'Concurrent Active / In Active';
    this.clickedVal = this.userList[e.dataPointIndex].isActive;
    this.clickedStageStatusVal = '';
  }

  handleTimeZoneChartClick(e: any): void {
    this.titleName = 'Task Type Report';
    this.visibleReportPopup = this.dialog.open(
      this.reportPopup,
      this.reportPopupConfig
    );
    this.tableDataList(
      'timeZone',
      this.timeZoneList[e.dataPointIndex].timezone,
      ''
    );
    this.clickedType = 'Timezone';
    this.clickedVal = this.timeZoneList[e.dataPointIndex].timezone;
    this.clickedStageStatusVal = '';
  }
  getTotalCountTimeZoneChart() {
    return this.timeZoneList.reduce(
      (total: number, item: { count: number }) => total + item.count,
      0
    );
  }
  handleGroupChartClick(e: any): void {
    this.titleName = 'Group';
    this.visibleReportPopup = this.dialog.open(
      this.reportPopup,
      this.reportPopupConfig
    );
    this.tableDataList('group', this.allGroupCount[e.dataPointIndex].value, '');
    this.clickedType = 'Group';
    this.clickedVal = this.allGroupCount[e.dataPointIndex].value;
    this.clickedStageStatusVal = '';
  }


  handleDepartmentChartClick(department: string): void {
    this.titleName = 'Task Type Report';
    this.visibleReportPopup = this.dialog.open(
      this.reportPopup,
      this.reportPopupConfig
    );
    this.tableDataList(
      'department',
      department,
      ''
    );
    this.clickedType = 'Department';
    this.clickedVal = department;
    this.clickedStageStatusVal = '';
  }

  // handleDepartmentChartClick(e: any): void {
  //   this.titleName = 'Task Type Report';
  //   this.visibleReportPopup = this.dialog.open(
  //     this.reportPopup,
  //     this.reportPopupConfig
  //   );
  //   this.tableDataList(
  //     'department',
  //     this.departmentList[e.dataPointIndex].department,
  //     ''
  //   );
  //   this.clickedType = 'Department';
  //   this.clickedVal = this.departmentList[e.dataPointIndex].department;
  //   this.clickedStageStatusVal = '';
  // }
  getTotalCountDepartment() {
    return this.departmentList.reduce(
      (total: number, item: { count: number }) => total + item.count,
      0
    );
  }

  handleDesignationChartClick(e: any): void {
    this.titleName = 'Task Type Report';
    this.visibleReportPopup = this.dialog.open(
      this.reportPopup,
      this.reportPopupConfig
    );
    this.tableDataList(
      'designation',
      this.designationList[e.dataPointIndex].designation,
      ''
    );
    this.clickedType = 'Designation';
    this.clickedVal = this.designationList[e.dataPointIndex].designation;
    this.clickedStageStatusVal = '';
  }
  getTotalCountDesignation() {
    return this.designationList.reduce(
      (total: number, item: { count: number }) => total + item.count,
      0
    );
  }

  handleUserLoginInactivityChartClick(e: any): void {
    this.titleName = 'User Login Inactivity';
    this.visibleReportPopup = this.dialog.open(
      this.reportPopup,
      this.reportPopupConfig
    );
    this.tableDataList(
      'UserLoginInactivity',
      this.UserLoginInactivityList[e.dataPointIndex].lastLogonBefore,
      ''
    );
    this.clickedType = 'User Login Inactivity';
    this.clickedVal =
      this.UserLoginInactivityList[e.dataPointIndex].lastLogonBefore;
    this.clickedStageStatusVal = '';
  }
  getTotalCountLoginInactivity() {
    return this.UserLoginInactivityList.reduce(
      (total: number, item: { count: number }) => total + item.count,
      0
    );
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(
      this.tableReportDataList.length,
      page,
      this.perPage,
      targetpage
    );
    if (this.tableReportDataList.length > 0) {
      this.pagedItems = this.tableReportDataList.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    }
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(
      this.TableReportDataListForUserLoginInactive.length,
      page,
      this.perPage,
      targetpage
    );
    if (this.TableReportDataListForUserLoginInactive.length > 0) {
      this.pagedItems1 = this.TableReportDataListForUserLoginInactive.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  setPage5(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(
      this.tableReportDataListTotal.length,
      page,
      this.perPage,
      targetpage
    );
    if (this.tableReportDataListTotal.length > 0) {
      this.pagedItems5 = this.tableReportDataListTotal.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    }
  }
  paginationCall5(value: number) {
    this.perPage = value;
    this.setPage5(this.pager.currentPage, 0);
  }
  setPage6(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(
      this.TableReportDataListForUserLoginInactiveTotal.length,
      page,
      this.perPage,
      targetpage
    );
    if (this.TableReportDataListForUserLoginInactiveTotal.length > 0) {
      this.pagedItems6 =
        this.TableReportDataListForUserLoginInactiveTotal.slice(
          this.pager.startIndex,
          this.pager.endIndex + 1
        );
    }
  }

  paginationCall6(value: number) {
    this.perPage = value;
    this.setPage6(this.pager.currentPage, 0);
  }
  typeForExcel: any;
  valueOfWhereForExcel: any;
  stageNameForExcel: any;

  tableDataList(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log("valueOfWhere=", valueOfWhere)
    this.typeForExcel = type;
    this.valueOfWhereForExcel = valueOfWhere;
    this.stageNameForExcel = stageNameForTable;
    let whereVals;
    if (type == 'isActive' && stageNameForTable == 'I') {
      this.showReportFlagValue = 1;
      if (valueOfWhere == 'Active') {
        whereVals = " WHERE USER_STATUS in ('Deactivation Approval Pending','User Deactivation Rejected','Active') ";
      } else if (valueOfWhere == 'User_Deactivated') {
        whereVals = " WHERE IS_USER_DEACTIVATED='Y' AND USER_STATUS = 'User Deactivated'";
      } else {
        whereVals = " WHERE USER_STATUS='Inactive'";
      }
    } else if (type == 'concurrent') {
      this.showReportFlagValue = 3;
      console.log('valueOfWhere=', valueOfWhere);
      if (valueOfWhere == 'Active') {
        whereVals = '';
      } else {
        whereVals = " WHERE IS_ACTIVE='Y'";
      }
    } else if (type == 'department') {
      this.showReportFlagValue = 1;
      if (valueOfWhere == 'undefined') {
        whereVals = ' WHERE DEPARTMENT IS NULL ';
      } else {
        whereVals = " WHERE DEPARTMENT='" + valueOfWhere + "'";
      }
    } else if (type == 'designation') {
      this.showReportFlagValue = 1;
      if (valueOfWhere == 'undefined') {
        whereVals = ' WHERE DESIGNATION IS NULL ';
      } else {
        whereVals = " WHERE DESIGNATION='" + valueOfWhere + "'";
      }
    } else if (type == 'timeZone') {
      this.showReportFlagValue = 1;
      if (valueOfWhere == 'undefined') {
        whereVals = ' WHERE TIMEZONE IS NULL ';
      } else {
        whereVals = " WHERE TIMEZONE='" + valueOfWhere + "'";
      }
    } else if (type == 'UserLoginInactivity') {
      this.showReportFlagValue = 2;
      whereVals = " WHERE LAST_LOGON_BEFORE='" + valueOfWhere + "'";
    } else if (type == 'group') {
      this.showReportFlagValue = 4;
    }
    this.whereValsForExcel = whereVals;
    let data = {
      wherVal: whereVals,
    };
    this.isProcessing = true;
    if (this.showReportFlagValue == 1) {
      forkJoin([this.appService.getTableAdminReportDataList(data)]).subscribe(
        ([stageList]) => {
          this.tableReportDataList = stageList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportDataList.length;
          this.totalPages = Math.ceil(
            this.tableReportDataList.length / this.itemsPerPage
          );
          this.setPage(1, 0);
          this.isProcessing = false;
        }
      );
    } else if (this.showReportFlagValue == 2) {
      forkJoin([
        this.appService.getTableAdminReportForUserLoginInactivityDataList(data),
      ]).subscribe(([UserLoginInactivityDataList]) => {
        this.TableReportDataListForUserLoginInactive =
          UserLoginInactivityDataList;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize =
          this.TableReportDataListForUserLoginInactive.length;
        this.totalPages = Math.ceil(
          this.TableReportDataListForUserLoginInactive.length /
          this.itemsPerPage
        );
        this.setPage1(1, 0);
        this.isProcessing = false;
      });
    } else if (this.showReportFlagValue == 3) {
      console.log('data=', data);
      console.log('valueOfWhere=', valueOfWhere);
      if (valueOfWhere == 'In Active') {
        console.log('valueOfWhere1=', valueOfWhere);
        forkJoin([
          this.appService.getTableAdminReportDataListWithoutConcurrent(data),
        ]).subscribe(([concurrentInactiveList]) => {
          this.tableReportDataList = concurrentInactiveList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportDataList.length;
          this.totalPages = Math.ceil(
            this.tableReportDataList.length / this.itemsPerPage
          );
          this.setPage(1, 0);
          this.isProcessing = false;
        });
      } else {
        console.log('valueOfWhere2=', valueOfWhere);
        forkJoin([this.appService.getOneQmsUserActiveUserRep(data)]).subscribe(
          ([concurrentList]) => {
            this.tableReportDataList = concurrentList;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.tableReportDataList.length;
            this.totalPages = Math.ceil(
              this.tableReportDataList.length / this.itemsPerPage
            );
            this.setPage(1, 0);
            this.isProcessing = false;
          }
        );
      }
    } else if (this.showReportFlagValue == 4) {
      this.typeOfGroup = valueOfWhere;
      if (valueOfWhere == 'QMS') {
        this.tableReportDataList = this.qmsList;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.tableReportDataList.length;
        this.totalPages = Math.ceil(
          this.tableReportDataList.length / this.itemsPerPage
        );
        this.setPage(1, 0);
        this.isProcessing = false;
      } else if (valueOfWhere == 'DMS') {
        this.tableReportDataList = this.dmsList;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.tableReportDataList.length;
        this.totalPages = Math.ceil(
          this.tableReportDataList.length / this.itemsPerPage
        );
        this.setPage(1, 0);
        this.isProcessing = false;
      } else if (valueOfWhere == 'TMS') {
        this.tableReportDataList = this.tmsList;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.tableReportDataList.length;
        this.totalPages = Math.ceil(
          this.tableReportDataList.length / this.itemsPerPage
        );
        this.setPage(1, 0);
        this.isProcessing = false;
      }
    }
  }
  tableDataListAll(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log('data', type);
    console.log('data', valueOfWhere);
    console.log('data', stageNameForTable);
    this.typeForExcel = type;
    this.valueOfWhereForExcel = valueOfWhere;
    this.stageNameForExcel = stageNameForTable;
    let whereVals = ' ';
    if (type == 'isActive' && stageNameForTable == 'I') {
      this.showReportFlagValueTotal = 6;
    } else if (
      type == 'department' ||
      type == 'designation' ||
      type == 'timeZone'
    ) {
      this.showReportFlagValueTotal = 6;
    } else if (type == 'UserLoginInactivity') {
      this.showReportFlagValueTotal = 7;
      whereVals = ' WHERE LAST_LOGON_BEFORE IS NOT NULL';
    }
    this.whereValsForExcel = whereVals;
    let data = {
      wherVal: whereVals,
    };
    this.isProcessing = true;
    if (this.showReportFlagValueTotal == 6) {
      forkJoin([this.appService.getTableAdminReportDataList(data)]).subscribe(
        ([stageListtotal]) => {
          this.tableReportDataListTotal = stageListtotal;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportDataListTotal.length;
          this.totalPages = Math.ceil(
            this.tableReportDataListTotal.length / this.itemsPerPage
          );
          this.setPage5(1, 0);
          this.isProcessing = false;
        }
      );
    } else if (this.showReportFlagValueTotal == 7) {
      forkJoin([
        this.appService.getTableAdminReportForUserLoginInactivityDataList(data),
      ]).subscribe(([UserLoginInactivityDataListTotal]) => {
        this.TableReportDataListForUserLoginInactiveTotal =
          UserLoginInactivityDataListTotal;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize =
          this.TableReportDataListForUserLoginInactiveTotal.length;
        this.totalPages = Math.ceil(
          this.TableReportDataListForUserLoginInactiveTotal.length /
          this.itemsPerPage
        );
        this.setPage6(1, 0);
        this.isProcessing = false;
      });
    } else if (this.showReportFlagValueTotal == 8) {
      console.log('data=', data);
      console.log('valueOfWhere=', valueOfWhere);
      if (valueOfWhere == 'Active') {
        console.log('valueOfWhere1=', valueOfWhere);
        forkJoin([
          this.appService.getTableAdminReportDataListWithoutConcurrent(data),
        ]).subscribe(([concurrentInactiveListTotal]) => {
          this.tableReportDataListTotal = concurrentInactiveListTotal;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.tableReportDataListTotal.length;
          this.totalPages = Math.ceil(
            this.tableReportDataListTotal.length / this.itemsPerPage
          );
          this.setPage5(1, 0);
          this.isProcessing = false;
        });
      } else {
        console.log('valueOfWhere2=', valueOfWhere);
        forkJoin([this.appService.getOneQmsUserActiveUserRep(data)]).subscribe(
          ([concurrentListTotal]) => {
            this.tableReportDataListTotal = concurrentListTotal;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.tableReportDataListTotal.length;
            this.totalPages = Math.ceil(
              this.tableReportDataListTotal.length / this.itemsPerPage
            );
            this.setPage5(1, 0);
            this.isProcessing = false;
          }
        );
      }
    } else if (this.showReportFlagValueTotal == 9) {
      this.typeOfGroup = valueOfWhere;
      if (valueOfWhere == 'QMS') {
        this.tableReportDataListTotal = this.qmsList;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.tableReportDataListTotal.length;
        this.totalPages = Math.ceil(
          this.tableReportDataListTotal.length / this.itemsPerPage
        );
        this.setPage5(1, 0);
        this.isProcessing = false;
      } else if (valueOfWhere == 'DMS') {
        this.tableReportDataListTotal = this.dmsList;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.tableReportDataListTotal.length;
        this.totalPages = Math.ceil(
          this.tableReportDataListTotal.length / this.itemsPerPage
        );
        this.setPage5(1, 0);
        this.isProcessing = false;
      } else if (valueOfWhere == 'TMS') {
        this.tableReportDataListTotal = this.tmsList;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.tableReportDataListTotal.length;
        this.totalPages = Math.ceil(
          this.tableReportDataListTotal.length / this.itemsPerPage
        );
        this.setPage5(1, 0);
        this.isProcessing = false;
      }
    }
  }
  userList: any = [];
  userList1: any = [];
  deactivatedList: any = [];
  userListConcurent: any = [];
  UserLoginInactivityList: any = [];
  userListExcluded: any = [];
  departmentList: any = [];
  designationList: any = [];
  timeZoneList: any = [];
  tmsList: any = [];
  qmsList: any = [];
  dmsList: any = [];
  allGroupCount: any = [];
  temp: any;
  async genReport() {
    this.isProcessing = true;

    const data = {

    };



    try {
      const [
        Deactivated,
        userList1,
        userListExcluded,
        departmentList,
        designationList,
        timeZoneList,
        UserLoginInactivityList,
        concurentList,
        userList,
        tmsList,
        qmsList,
        dmsList,
      ] = await Promise.all([
        firstValueFrom(
          this.appService.statusReportForDeactivated()
        ),
        firstValueFrom(
          this.appService.getUserRepListForStatus()
        ),
        firstValueFrom(
          this.appService.getUserRepListForStatusExcluded()
        ),
        firstValueFrom(
          this.appService.getUserRepListForDepartment()
        ),
        firstValueFrom(
          this.appService.getUserRepListForDesignation()
        ),
        firstValueFrom(
          this.appService.getUserRepListForTimeZone()
        ),
        firstValueFrom(
          this.appService.getUserLoginInactivityList()
        ),
        firstValueFrom(
          this.appService.getOneQmsUserActiveUserRep(data)
        ),
        firstValueFrom(
          this.appService.getUserRepListForStatus()
        ),
        firstValueFrom(
          this.appService.getTmsGroupsVwDetails()
        ),
        firstValueFrom(
          this.appService.getQmsGroups()
        ),
        firstValueFrom(
          this.appService.getDmsGroupsVwDetails()
        ),
      ]);

      this.userList = userList;
      this.userList1 = userList1;
      this.userListExcluded = userListExcluded;
      this.designationList = designationList;
      this.timeZoneList = timeZoneList;
      this.departmentList = departmentList;
      this.UserLoginInactivityList = UserLoginInactivityList;
      this.userListConcurent = concurentList;
      this.tmsList = tmsList;
      this.qmsList = qmsList;
      this.dmsList = dmsList;

      this.temp =
        this.userList1[0].isActive == 'In Active'
          ? this.userList1[1].count
          : this.userList1[0].count;

      this.groupCountCal();
      this.concurentUsercountCal();

      this.deactivatedList = Deactivated;

      console.log('this.deactivatedList ==', this.deactivatedList);

      this.userList1 = [...this.deactivatedList];

      console.log('this.userList1 ==', this.userList1);

      this.createChart();
    } catch (error) {
      console.error('Error in genReport:', error);
    } finally {
      this.isProcessing = false;
    }
  }

  concurentUsercountCal() {
    this.userList.forEach((item: any, index: any) => {
      if (item.isActive == 'Active') {
        item.count = this.userListConcurent.length;
      } else if (item.isActive == 'In Active') {
        item.count = this.temp - this.userListConcurent.length;
      }
    });
  }

  groupCountCal() {
    this.allGroupCount = [
      { value: 'QMS', count: this.qmsList.length },
      { value: 'TMS', count: this.tmsList.length },
      { value: 'DMS', count: this.dmsList.length },
    ];
  }
  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tableReportDataList.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      this.pagedItems = this.tableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(
              columnValue,
              this.appService.organizationDetails?.dateFormat
                ? 'dd-MMM-yyyy'
                : this.appService.organizationDetails?.dateFormat
            );
            console.log('columnValue2=', formattedDate);
            return formattedDate
              ? formattedDate.toString().toLowerCase().includes(filter)
              : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        return false;
      });
    }
  }
  applyFilter1(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    if (filter === '') {
      this.pagedItems1 = this.TableReportDataListForUserLoginInactive.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      this.pagedItems1 = this.TableReportDataListForUserLoginInactive.filter(
        (item: any) => {
          const columnValue = item[column];
          // Check if columnValue is a string before calling toLowerCase()
          if (val === 'd') {
            if (columnValue) {
              let formattedDate = this.datePipe.transform(
                columnValue,
                this.appService.organizationDetails?.dateFormat
                  ? 'dd-MMM-yyyy'
                  : this.appService.organizationDetails?.dateFormat
              );
              console.log('columnValue2=', formattedDate);
              // Convert number to string before checking for inclusion
              return formattedDate
                ? formattedDate.toString().toLowerCase().includes(filter)
                : false;
            } else {
              return false;
            }
          } else if (typeof columnValue === 'string') {
            return columnValue.toLowerCase().includes(filter);
          } else if (typeof columnValue === 'number') {
            // Convert number to string before checking for inclusion
            return columnValue.toString().toLowerCase().includes(filter);
          } else if (columnValue instanceof Date) {
            // Format date to string before checking for inclusion
            const formattedDate = columnValue.toISOString().substring(0, 10);
            return formattedDate.toLowerCase().includes(filter);
          }
          // If it's not a string, return false to exclude it from filtering
          return false;
        }
      );
    }
  }
  applyFilter5(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    if (filter === '') {
      this.pagedItems5 = this.tableReportDataListTotal.slice(
        this.pager.startIndex,
        this.pager.endIndex + 1
      );
    } else {
      this.pagedItems5 = this.tableReportDataListTotal.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(
              columnValue,
              this.appService.organizationDetails?.dateFormat
                ? 'dd-MMM-yyyy'
                : this.appService.organizationDetails?.dateFormat
            );
            console.log('columnValue2=', formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate
              ? formattedDate.toString().toLowerCase().includes(filter)
              : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter6(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    if (filter === '') {
      this.pagedItems6 =
        this.TableReportDataListForUserLoginInactiveTotal.slice(
          this.pager.startIndex,
          this.pager.endIndex + 1
        );
    } else {
      this.pagedItems6 =
        this.TableReportDataListForUserLoginInactiveTotal.filter(
          (item: any) => {
            const columnValue = item[column];
            // Check if columnValue is a string before calling toLowerCase()
            if (val === 'd') {
              if (columnValue) {
                let formattedDate = this.datePipe.transform(
                  columnValue,
                  this.appService.organizationDetails?.dateFormat
                    ? 'dd-MMM-yyyy'
                    : this.appService.organizationDetails?.dateFormat
                );
                console.log('columnValue2=', formattedDate);
                // Convert number to string before checking for inclusion
                return formattedDate
                  ? formattedDate.toString().toLowerCase().includes(filter)
                  : false;
              } else {
                return false;
              }
            } else if (typeof columnValue === 'string') {
              return columnValue.toLowerCase().includes(filter);
            } else if (typeof columnValue === 'number') {
              // Convert number to string before checking for inclusion
              return columnValue.toString().toLowerCase().includes(filter);
            } else if (columnValue instanceof Date) {
              // Format date to string before checking for inclusion
              const formattedDate = columnValue.toISOString().substring(0, 10);
              return formattedDate.toLowerCase().includes(filter);
            }
            // If it's not a string, return false to exclude it from filtering
            return false;
          }
        );
    }
  }

  //Excell & PDF
  popupDataTitle: any = {};
  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: false,
    singleSelection: false,
    itemsShowLimit: 2,
  };
  cancelReportPopup() {
    this.manuallyPicked = false;
    this.selectedColumns = '';
    this.visibleExcelPdfPopup.close();
  }

  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (
      value == 'Pdf' &&
      this.manuallyPicked &&
      this.selectedColumns.length > 12
    ) {
      alert(
        'Selected columns exceeded the limit. Limit 12, Selected ' +
        this.selectedColumns.length
      );
    } else {
      let tname = '';
      let colList = '';
      let fieldList = '';
      let orderBy = '';
      if (this.showReportFlagValue == 1) {
        tname = 'ONEQMS_USERS_VW';
        colList =
          'USER_NAME,USER_FULL_NAME,IS_AD_USER,DESIGNATION,DEPARTMENT,MANAGER_NAME,EMAIL_ADDRESS,CONTACT_NUMBER,COUNTRY,CITY,TIMEZONE,IS_ACTIVE,IS_USER_DEACTIVATED,CREATED_ON,UPDATED_ON,CREATED_BY_USER,UPDATED_BY_USER';
        fieldList =
          'User Name,User Full Name,Is AD User,Designation,Department,Manager Name,Email Address,Contact Number,Country,City,Timezone,Is Active,Is User Deactivated,Created On,Updated On,Created By,Updated By';
        orderBy = 'USER_ID';
      } else if (this.showReportFlagValue == 2) {
        tname = 'ONEQMS_USER_LOGIN_INACTIVITY_REP_VW';
        colList =
          'USER_NAME,LAST_NAME,FIRST_NAME,DESIGNATION,DEPARTMENT,EMAIL_ADDRESS,COUNTRY_NAME,CITY,TIMEZONE,LAST_LOGON_DATE,CREATED_ON,LAST_LOGON_BEFORE';
        fieldList =
          'User Name,Last Name,First Name,Designation,Department,Email Address,Country,City,Timezone,Last Logon Date,Created On,Last Logon Before';
      } else if (this.showReportFlagValue == 3) {
        if (this.valueOfWhereForExcel == 'Active') {
          tname = 'ONEQMS_USERS_VW';
          colList =
            'USER_NAME,USER_FULL_NAME,IS_AD_USER,DESIGNATION,DEPARTMENT,MANAGER_NAME,EMAIL_ADDRESS,CONTACT_NUMBER,COUNTRY,CITY,TIMEZONE,IS_ACTIVE,CREATED_ON,UPDATED_ON,CREATED_BY_USER,UPDATED_BY_USER';
          fieldList =
            'User Name,User Full Name,Is AD User,Designation,Department,Manager Name,Email Address,Contact Number,Country,City,Timezone,Is Active,Created On,Updated On,Created By,Updated By';
          orderBy = 'USER_ID';
          this.whereValsForExcel =
            ' WHERE TOKEN_ID IS NOT NULL AND LAST_USER_ACCESSED_ON >  SYSDATE - (1/96) AND ORG_ID=' +
            this.message.getOrgId();
          console.log(' this.whereValsForExcel =', this.whereValsForExcel);
        } else {
          tname = 'ONEQMS_USERS_VW';
          colList =
            'USER_NAME,USER_FULL_NAME,IS_AD_USER,DESIGNATION,DEPARTMENT,MANAGER_NAME,EMAIL_ADDRESS,CONTACT_NUMBER,COUNTRY,CITY,TIMEZONE,IS_ACTIVE,CREATED_ON,UPDATED_ON,CREATED_BY_USER,UPDATED_BY_USER';
          fieldList =
            'User Name,User Full Name,Is AD User,Designation,Department,Manager Name,Email Address,Contact Number,Country,City,Timezone,Is Active,Created On,Updated On,Created By,Updated By';
          this.whereValsForExcel =
            " USRS WHERE IS_ACTIVE='Y' AND NOT EXISTS (SELECT USER_ID FROM ONEQMS_USERS WHERE TOKEN_ID IS NOT NULL AND LAST_USER_ACCESSED_ON >  SYSDATE - (1/96) AND ORG_ID = USRS.ORG_ID AND USER_ID = USRS.USER_ID)";
          console.log(' this.whereValsForExcel 1=', this.whereValsForExcel);
        }
      } else if (this.showReportFlagValue == 4) {
        if (this.typeOfGroup == 'TMS') {
          tname = 'TMS_GROUPS_VW';
          colList =
            'GROUP_NAME,GROUP_DESCRIPTION,CC_REMINDER_EMAIL_TO_RM,ADDL_DUE_REMINDER_EMAILS,ADDL_DUE_ESCALATION_EMAILS,MAX_ATTEMPT_ESCALATION_EMAILS,IS_ACTIVE,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON';
          fieldList =
            'Group Name,Group Description,CC Reminder Email to RM,Addl Due Reminder Emails,Addl Due Escalation Emails,Max Attempt Escalation Emails,Is Active,Created By,Created On,Updated By,Update On';
          this.whereValsForExcel =
            ' WHERE ORG_ID=' + this.message.getOrgId();
        } else if (this.typeOfGroup == 'DMS') {
          tname = 'DMS_GROUPS_VW';
          colList =
            'GROUP_NAME,GROUP_DESCRIPTION,IS_ACTIVE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER';
          fieldList =
            'Group Name,Group Description,Is Active,Created On,Created By,Updated On,Updated By';
          this.whereValsForExcel =
            ' WHERE ORG_ID=' + this.message.getOrgId();
        } else if (this.typeOfGroup == 'QMS') {
          tname = 'QMS_GROUPS_VW';
          colList =
            'GROUP_CODE,GROUP_NAME,GROUP_DESCRIPTION,MODULES,IS_ACTIVE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER';
          fieldList =
            'Group Code,Group Name,Group Description,Modules,Is Active,Created On,Created By,Updated On,Updated By';
          this.whereValsForExcel =
            ' WHERE ORG_ID=' + this.message.getOrgId();
        }
      }
      console.log(value, '--------------------');
      let wherVal: string;
      if (this.whereValsForExcel == null) {
        wherVal = '';
      } else {
        wherVal = this.whereValsForExcel;
      }
      console.log(' wherVal =', wherVal);
      const data = {

        wherVal: wherVal,
      };

      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: '',
        orderByClause: orderBy,
        fieldSizeList: '',
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: this.statusCodeValue,
        codelistGroup: null,
        manualEntryDataFields: null,
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: null,
        reModule: 'admin',
        logoId: 0,
        module: 'Admin',
        footer: this.selectedReportFooter,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? `${this.clickedType}_${this.clickedVal}`,
        currentStatus: 'NA',
        groupName: this.reportName + '',
      };

      this.reportObj = { ...data1, ...data };
      debugger;

      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
        .format(new Date(timestamp))
        .replaceAll(',', '')
        .replaceAll(' ', '_');
      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
      const fileName = `${this.clickedType}_${this.clickedVal}_${formattedDate}.${fileType}`;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj,
          title: 'Report',
          columns: [],
          informationTab: {
            'Report Name': `${this.clickedType}_${this.clickedVal}` + ' Report',
            'Exported By': localStorage.getItem('loggedUserName'),
          },
        };
        this.appService.downloadexcelForChart(pdfData, fileName);
      } else {
        const pdfData = {
          ...this.reportObj,
          title: `${this.clickedType}_${this.clickedVal}` + ' Report',
          pdfPageSize: this.excelPdf.pdfPageSize,
          columns: this.manuallyPicked
            ? this.selectedColumns.join(',')
            : this.columnList.split(',').slice(0, 10).join(','),
        };
        this.appService.downloadPdfForChart(pdfData, fileName);
      }
    }
  }
  pdfPageSizes: any = [];
  maxCountReached: boolean = false;
  openReportPopup(item: any) {
    console.log(this.showReportFlagValue, '-------------------------');
    if (this.showReportFlagValue == 1) {
      this.columnList =
        'User Name,User Full Name,Is AD User,Designation,Department,Manager Name,Email Address,Contact Number,Country,City,Timezone,Is Active,,Is User Deactivated,Created On,Updated On,Created By,Updated By';
    } else if (this.showReportFlagValue == 2) {
      this.columnList =
        'User Name,Last Name,First Name,Designation,Department,Email Address,Country,City,Timezone,Last Logon Date,Created On,Last Logon Before';
    } else if (this.showReportFlagValue == 3) {
      this.columnList =
        'User Name,User Full Name,Is AD User,Designation,Department,Manager Name,Email Address,Contact Number,Country,City,Timezone,Is Active,Created On,Updated On,Created By,Updated By';
    } else if (this.showReportFlagValue == 4) {
      if (this.typeOfGroup == 'TMS') {
        this.columnList =
          'Group Name,Group Description,CC Reminder Email to RM,Addl Due Reminder Emails,Addl Due Escalation Emails,Max Attempt Escalation Emails,Is Active,Update Reason';
      } else if (this.typeOfGroup == 'DMS') {
        this.columnList =
          'Group Name,Group Description,Is Active,Update Reason,Created On,Created By,Updated On,Updated By';
      } else if (this.typeOfGroup == 'QMS') {
        this.columnList =
          'Group Code,Group Name,Group Description,Modules,Is Active,Created On,Created By,Updated On,Updated By';
      }
    }

    this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    this.pdfPageSizes = JSON.parse(
      sessionStorage.getItem('pdfPageSizes') ?? '{}'
    );
    this.excelPdf.pdfPageSize = 'A4';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [
      false,
      false,
      [],
    ];
    this.pdfSelection = false;
    this.reportName = 'Admin_Report_' + this.qmsservice.adminReportFor;
    this.visibleExcelPdfPopup = this.dialog.open(
      this.excelPdfPopup,
      this.excelPdfPopupConfig
    );
    this.isSaveReport = false;
  }
  manuallyPicked: boolean;
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [
        false,
        false,
        [],
      ];
    }
  }

  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true;
        else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfSelection =
          this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  //end excell & pdf
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName:
          this.message.breadcrumbData.thirdLevel ??
          this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isExeclPdf = ['execl-pdf'].includes(fieldId);
    const isSelected = isExeclPdf ? !selectedItems.length : !selectedItems;
    const isFieldValid = field;
    if (isSelected && isFieldValid) {
      field.style.color = 'red';
    } else {
      field.style.color = '#005c8a';
    }
  }
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfSelection)
        this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect());
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns);
        this.convertArrayToString(this.selectedColumns);
      });
    } else if (value == 'columns') {
      if (this.isAllColumns)
        this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect());
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true;
        else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }

  selectedColumnsAsString: string = '';

  @Input() excelPdf: any = {};
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }
  pdfSearchText: string = '';
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log(
        'this.dropDownDataForReportLogo=',
        this.dropDownDataForReportLogo
      );
      console.log(
        'this.dropDownDataForReportLogo.reportImageList',
        this.dropDownDataForReportLogo.reportImageList
      );
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default',
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(',')) {
        this.imageIdList =
          this.dropDownDataForReportLogo.reportImageList.split(',');
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default',
            });
          } else {
            console.log('this.imageIdList=', this.imageIdList);
            console.log(
              'this.organizationReportImageDetails=',
              this.organizationReportImageDetails.length
            );
            for (const imageDetail of this.organizationReportImageDetails) {
              console.log(
                'this.organizationReportImageDetails=',
                imageDetail.reportImageId,
                this.imageIdList[i]
              );

              if (imageDetail.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: imageDetail.reportImageId,
                  displayExp: imageDetail.reportImageName,
                });
              }
            }
          }
        }
      } else {
        for (const imageDetail of this.organizationReportImageDetails) {
          if (
            imageDetail.reportImageId ==
            this.dropDownDataForReportLogo.reportImageList
          ) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: imageDetail.reportImageId,
              displayExp: imageDetail.reportImageName,
            });
          }
        }
      }
      if (
        this.dropDownDataForReportLogo.defaultReportName != 'Default' &&
        this.dropDownDataForReportLogo.defaultReportName != null
      ) {
        for (const reportLogo of this.reportLogoDropdown) {
          if (
            reportLogo.valueExp ==
            this.dropDownDataForReportLogo.defaultReportName
          ) {
            this.selectedReportLogoValue = reportLogo.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0);
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService
      .getCodeListsByGroup('REPORT_FOOTER')
      .subscribe({
        next:
          (data: any) => {
            this.reportFooterDropdown1 = data;
            console.log('data', this.reportFooterDropdown1);

            this.selectBoxForFooter();
            if (this.reportFooterDropdown.length > 0) {
              this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
            }

            this.isProcessing = false;
          }, error:
          (error: any) => {
            this.isProcessing = false;
          }
      });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (
        vals.moduleList == 'Common' ||
        vals.moduleList.includes(this.qmsservice.moduleName)
      ) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName,
        });
      }
    }
  }
  organizationPrivelegesDetails: any = [];
  isQMS: boolean = false;
  isDMS: boolean = false;
  isTRN: boolean = false;
  ngOnInit() {
    this.qmsservice.adminReportFor = 'Default';
    this.isProcessing = true;
    this.genReport();
    this.ngOnChangesReportFooter();
    this.appService.getOneQmsOrganizationPrivileges().subscribe((data: any) => {

      if (data.cr == "Y" || data.capa == "Y" || data.dv == "Y" || data.au == "Y" || data.in == "Y" || data.qi == "Y" || data.cc == "Y" || data.OOS == "Y") {
        this.isQMS = true;
      } else {
        this.isQMS = false;
      }
      this.isTRN = data.trn == "Y";
      this.isDMS = data.docs == "Y";

      console.log(this.isQMS, "=this.isQMS");
      console.log(this.isTRN, "=data.trn");
      console.log(this.isDMS, "=data.docs");
      this.organizationPrivelegesDetails = data;

    })
  }
  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  // excelPdf: any = {};
  openReport(reportType: string) {
    let tname = '';
    let colList = '';
    let fieldList = '';
    let orderBy = '';
    if (this.showReportFlagValue == 1) {
      tname = 'ONEQMS_USERS_VW';
      colList =
        'USER_NAME,USER_FULL_NAME,IS_AD_USER,DESIGNATION,DEPARTMENT,MANAGER_NAME,EMAIL_ADDRESS,CONTACT_NUMBER,COUNTRY,CITY,TIMEZONE,IS_ACTIVE,IS_USER_DEACTIVATED,CREATED_ON,UPDATED_ON,CREATED_BY_USER,UPDATED_BY_USER';
      fieldList =
        'User Name,User Full Name,Is AD User,Designation,Department,Manager Name,Email Address,Contact Number,Country,City,Timezone,Is Active,Is User Deactivated,Created On,Updated On,Created By,Updated By';
      orderBy = 'USER_ID';
    } else if (this.showReportFlagValue == 2) {
      tname = 'ONEQMS_USER_LOGIN_INACTIVITY_REP_VW';
      colList =
        'USER_NAME,LAST_NAME,FIRST_NAME,DESIGNATION,DEPARTMENT,EMAIL_ADDRESS,COUNTRY_NAME,CITY,TIMEZONE,LAST_LOGON_DATE,CREATED_ON,LAST_LOGON_BEFORE';
      fieldList =
        'User Name,Last Name,First Name,Designation,Department,Email Address,Country,City,Timezone,Last Logon Date,Created On,Last Logon Before';
    } else if (this.showReportFlagValue == 3) {
      if (this.valueOfWhereForExcel == 'Active') {
        tname = 'ONEQMS_USERS_VW';
        colList =
          'USER_NAME,USER_FULL_NAME,IS_AD_USER,DESIGNATION,DEPARTMENT,MANAGER_NAME,EMAIL_ADDRESS,CONTACT_NUMBER,COUNTRY,CITY,TIMEZONE,IS_ACTIVE,IS_USER_DEACTIVATED,CREATED_ON,UPDATED_ON,CREATED_BY_USER,UPDATED_BY_USER';
        fieldList =
          'User Name,User Full Name,Is AD User,Designation,Department,Manager Name,Email Address,Contact Number,Country,City,Timezone,Is Active,Is User Deactivated,Created On,Updated On,Created By,Updated By';
        this.whereValsForExcel =
          ' WHERE TOKEN_ID IS NOT NULL AND LAST_USER_ACCESSED_ON >  SYSDATE - (1/96) AND ORG_ID=' +
          this.message.getOrgId();
      } else {
        tname = 'ONEQMS_USERS_VW';
        colList =
          'USER_NAME,USER_FULL_NAME,IS_AD_USER,DESIGNATION,DEPARTMENT,MANAGER_NAME,EMAIL_ADDRESS,CONTACT_NUMBER,COUNTRY,CITY,TIMEZONE,IS_ACTIVE,IS_USER_DEACTIVATED,CREATED_ON,UPDATED_ON,CREATED_BY_USER,UPDATED_BY_USER';
        fieldList =
          'User Name,User Full Name,Is AD User,Designation,Department,Manager Name,Email Address,Contact Number,Country,City,Timezone,Is Active,Is User Deactivated,Created On,Updated On,Created By,Updated By';
        orderBy = 'USER_ID';
      }
    } else if (this.showReportFlagValue == 4) {
      if (this.typeOfGroup == 'TMS') {
        tname = 'TMS_GROUPS_VW';
        colList =
          'GROUP_NAME,GROUP_DESCRIPTION,CC_REMINDER_EMAIL_TO_RM,ADDL_DUE_REMINDER_EMAILS,ADDL_DUE_ESCALATION_EMAILS,MAX_ATTEMPT_ESCALATION_EMAILS,IS_ACTIVE,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON';
        fieldList =
          'Group Name,Group Description,CC Reminder Email to RM,Addl Due Reminder Emails,Addl Due Escalation Emails,Max Attempt Escalation Emails,Is Active,Created By,Created On,Updated By,Update On';
        this.whereValsForExcel =
          ' WHERE ORG_ID=' + this.message.getOrgId();
      } else if (this.typeOfGroup == 'DMS') {
        tname = 'DMS_GROUPS_VW';
        colList =
          'GROUP_NAME,GROUP_DESCRIPTION,IS_ACTIVE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER';
        fieldList =
          'Group Name,Group Description,Is Active,Created On,Created By,Updated On,Updated By';
        this.whereValsForExcel =
          ' WHERE ORG_ID=' + this.message.getOrgId();
      } else if (this.typeOfGroup == 'QMS') {
        tname = 'QMS_GROUPS_VW';
        colList =
          'GROUP_CODE,GROUP_NAME,GROUP_DESCRIPTION,MODULES,IS_ACTIVE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER';
        fieldList =
          'Group Code,Group Name,Group Description,Modules,Is Active,Created On,Created By,Updated On,Updated By';
        this.whereValsForExcel =
          ' WHERE ORG_ID=' + this.message.getOrgId();
      }
    }
    this.excelPdf.tableOrView_Name = tname;
    this.excelPdf.columnList_DB = colList;
    this.excelPdf.columnList_Report = fieldList;
    this.excelPdf.whereClause_Report = this.whereValsForExcel;
    this.excelPdf.reportType = 'Static';
    this.excelPdf.orderBy = orderBy;
    this.excelPdf.reportName =
      `${this.clickedType}_${this.clickedVal}` + ' Report';
    this.excelPdf.dropDown = fieldList?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }





}

